import { ZuiTableBaseElement } from './base.js';
import { html } from 'lit';
import { style } from './zui-table-footer-css.js';

/**
 * Footer table element, should come as the last item passed into a `<zui-table>`.
 *
 * @element zui-table-footer
 *
 * @slot - Default, unnamed slot; for inserting table footer content into `<zui-table-footer>`
 *
 * @cssprop [--zui-table-footer-margin=0.625rem (10px)] - Override the margin between the table and footer of the table
 */
export class ZuiTableFooterElement extends ZuiTableBaseElement {
  static get styles() {
    return [super.styles, style];
  }

  render() {
    return html`<div class="footer">
      <slot></slot>
    </div>`;
  }
}

window.customElements.define('zui-table-footer', ZuiTableFooterElement);

declare global {
  interface HTMLElementTagNameMap {
    'zui-table-footer': ZuiTableFooterElement;
  }
}
